


export enum BarColor {
	main = 'main',
	blue = 'blue',
	yellow = 'yellow',
	green = 'green',
	red = 'red'
}